import { useTheme } from '@mui/material';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';
import { startCase } from 'lodash-es';
import { Fragment, useMemo } from 'react';

import { getFormattedObjectChange } from './util';

interface ObjectChangesProps {
  objectChanges: Record<string, string[]>;
  isLastChange: boolean;
}

export const ObjectChanges = ({ objectChanges, isLastChange }: ObjectChangesProps) => {
  const theme = useTheme();

  const formattedTimeline = useMemo(
    () =>
      Object.entries(objectChanges)
        .map(([key, value]) => getFormattedObjectChange(key, value))
        .filter(Boolean),
    [objectChanges],
  );

  return (
    <>
      {isLastChange
        ? t('dispatch.order_audit_log.order_created')
        : t('dispatch.order_audit_log.order_updated')}
      <Typography variant={'body2'} sx={{ color: theme.brandV2.colors.treadGray2 }}>
        {formattedTimeline.map((change, index) => {
          if (!change) return null;
          const [name, value] = change;
          return (
            <Fragment key={name}>
              <strong>{startCase(name)}</strong>
              {value}
              {index < formattedTimeline.length - 1 ? ', ' : ''}
            </Fragment>
          );
        })}
      </Typography>
    </>
  );
};
